import React from "react";

import logoParadigma from "../images/logo.png";
import logoDatafolha from "../images/datafolha-branco.png";
import logoCoinbase from "../images/coinbase-branco.png";
import logoHashdex from "../images/hashdex.png";
import logoAbcripto from "../images/abcripto-branco.png";

// alturaVisivel equilibra os logos opticamente: cada marca tem proporções
// próprias, então casar só a largura deixaria umas maiores que as outras.
const marcas = [
  {
    nome: "Paradigma",
    src: logoParadigma,
    largura: 1020,
    altura: 284,
    alturaVisivel: 28,
    site: "https://paradigma.education/",
  },
  {
    nome: "Datafolha",
    src: logoDatafolha,
    largura: 246,
    altura: 47,
    alturaVisivel: 17,
    site: "https://datafolha.folha.uol.com.br/",
  },
  {
    nome: "Coinbase",
    src: logoCoinbase,
    largura: 800,
    altura: 143,
    alturaVisivel: 17,
    site: "https://www.coinbase.com/pt-br",
  },
  {
    nome: "Hashdex",
    src: logoHashdex,
    largura: 690,
    altura: 154,
    alturaVisivel: 24,
    site: "https://hashdex.com/pt-BR",
  },
  {
    nome: "ABCripto",
    src: logoAbcripto,
    largura: 293,
    altura: 63,
    alturaVisivel: 20,
    site: "https://abcripto.com.br/",
  },
];

const Footer = () => {
  return (
    <div className="section_footer">
      <div className="footer-wrapper">
        <div className="footer-wrapper-logo">
          {marcas.map(({ nome, src, largura, altura, alturaVisivel, site }) => (
            <div className="footer-logo" key={nome}>
              <a href={site} target="_blank" rel="noreferrer">
                <img
                  src={src}
                  alt={nome}
                  width={largura}
                  height={altura}
                  decoding="async"
                  style={{ "--altura-logo": `${alturaVisivel}px` }}
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Footer;
